import styled from "styled-components"
import { useTranslate } from "~/ur-react-hooks"
import { useOrganizationMembership } from "~/utils/hooks/useOrganizationMembership"
import { trpc } from "~/utils/trpc"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

const Content = styled.div`
  width: 290px;
  text-align: center;
  line-height: 150%;
`

const SchoolTitle = styled.h4`
  margin-top: 0;
  font-size: 18px;
`

const Description = styled.p``

const AdminInfo = styled.div``

const StyledLink = styled.a`
  color: ${(props) => props.theme.colors.secondary50};
  text-decoration: underline;

  display: flex;
  flex-direction: column;
`

export type SubscriptionSchoolMemberProps = {}

const SubscriptionSchoolMember: React.FC<
  SubscriptionSchoolMemberProps
> = () => {
  const organizationMembership = useOrganizationMembership()!

  const translations = useTranslate({
    description: "subscription-school-member.description",
  })

  const { data: adminUsers, isLoading } =
    trpc.users.getOrganizationUsers.useQuery({
      organizationId: organizationMembership.organizationId,
      filter: {
        roleIn: ["ADMIN", "OWNER"],
      },
    })

  const adminUser = adminUsers?.[0]

  return (
    <Layout>
      <Card>
        <Content>
          <SchoolTitle>{organizationMembership.organization.name}</SchoolTitle>
          <Description>{translations.description}</Description>
          {!isLoading && adminUser && (
            <AdminInfo>
              <b>{`${adminUser.firstName} ${adminUser.lastName}`.trim()}</b>
              <StyledLink href={`mailto:${adminUser.email}`}>
                {adminUser.email}
              </StyledLink>
            </AdminInfo>
          )}
        </Content>
      </Card>
    </Layout>
  )
}

export default SubscriptionSchoolMember
